import React from "react";

const ConnectionStatus = () => {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v2-header-wrapper has-subtitle">
          <div className="app-v2-header-left">
            <span className="app-v2-header-title">Trạng thái kết nối trang</span>
            <span className="app-v2-header-subtitle">
              Trạng thái kết nối Viettel Social với trang Facebook của bạn.
            </span>
          </div>
        </div>
        <div className="app-v2-connection-status">
          <div className="app-v2-connection-status-container">
            <div className="page-profile">
              <span
                content="ĐỎ ĐEN"
                className="app-avatar page-avatar app-avatar-lg app-avatar-circle app-avatar-image"
                style={{ background: "rgb(41, 121, 255)" }}
              >
                <img src="/call/social_avatar_api/profile_avatar/participants/637254356905824/channels/1/pages/637254356905824/?size=100" />
              </span>
              <div className="page-title">ĐỎ ĐEN</div>
            </div>
            <div className="page-connections--status">
              <div className="connections--row">
                <div className="collapse-container">
                  <div className="collapse-heading">
                    <div className="collapse-heading--wrapper">
                      <div className="title">
                        Trạng thái cấp quyền đồng bộ hội thoại
                      </div>
                      <div className="status">
                        <div
                          className="svg-next-icon"
                          style={{
                            background:
                              "url('https://static.harasocial.com/svg-funnel/ic_c_check.svg')",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundSize: "20px",
                            width: "20px",
                            height: "20px",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="arrow collapsed">
                      <div
                        className="svg-next-icon"
                        style={{
                          backgroundColor: "rgb(108, 121, 143)",
                          maskImage:
                            "url('https://static.harasocial.com/svg-funnel/ic-arrow-down-line-black.svg')",
                          maskRepeat: "no-repeat",
                          maskSize: "16px",
                          width: "16px",
                          height: "16px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="collapse-body"></div>
                </div>
              </div>
              <div className="connections--row">
                <div className="collapse-container">
                  <div className="collapse-heading">
                    <div className="collapse-heading--wrapper">
                      <div className="title">
                        Trạng thái sử dụng giao thức chuyển giao (Handover
                        Protocol)
                      </div>
                      <div className="status">
                        <div
                          className="svg-next-icon"
                          style={{
                            background:
                              "url('https://static.harasocial.com/svg-funnel/ic_c_warning.svg')",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundSize: "20px",
                            width: "20px",
                            height: "20px",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="arrow collapsed">
                      <div
                        className="svg-next-icon"
                        style={{
                          backgroundColor: "rgb(108, 121, 143)",
                          maskImage:
                            "url('https://static.harasocial.com/svg-funnel/ic-arrow-down-line-black.svg')",
                          maskRepeat: "no-repeat",
                          maskSize: "16px",
                          width: "16px",
                          height: "16px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="collapse-body">
                    <div className="collapse-body--visible">
                      <div className="connection-warnings">
                        <div className="app-alert-container warning connection-warnings--item">
                          <div className="app-alert-container__block">
                            <div className="app-alert--icon">
                              <div
                                className="svg-next-icon"
                                style={{
                                  background:
                                    "url('https://static.harasocial.com/svg-funnel/ic_faq.svg')",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center center",
                                  backgroundSize: "32px",
                                  width: "32px",
                                  height: "32px",
                                }}
                              ></div>
                            </div>
                            <p>
                              <b></b>Để các chức năng nhắn tin và trả lời tự
                              động hoạt động ổn định, bạn cần cài đặt giao thức
                              chuyển giao chính, cho phép Viettel Social xử lý tất
                              cả hội thoại.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="connection--hop">
                        <div className="hop--content">
                          <div className="hop--title">
                            Ứng dụng chính nhận giao thức chuyển giao
                          </div>
                          <div className="hop--description">
                            Sử dụng giao thức chuyển giao để quản lý các ứng
                            dụng khác nhau <br />
                            tương tác trong cùng một cuộc trò chuyện.
                          </div>
                        </div>
                        <div className="hop--apps">Ứng dụng khác</div>
                      </div>
                    </div>
                  </div>
                  <div className="collapse-footer">
                    <button
                      type="button"
                      className="app-btn app-btn-link btn-expand"
                    >
                      <span className="btn-expand--title">Xem thêm</span>
                      <div
                        className="svg-next-icon btn-expand--icon"
                        style={{
                          backgroundColor: "rgb(108, 121, 143)",
                          maskImage:
                            "url('https://static.harasocial.com/svg-funnel/ic-arrow-down-line-black.svg')",
                          maskRepeat: "no-repeat",
                          maskSize: "12px",
                          width: "12px",
                          height: "12px",
                        }}
                      ></div>
                    </button>
                  </div>
                </div>
              </div>
              <div className="connections--row">
                <div className="collapse-container">
                  <div className="collapse-heading">
                    <div className="collapse-heading--wrapper">
                      <div className="title">
                        Trạng thái MPS (tin nhắn mỗi giây)
                      </div>
                      <div className="status">
                        <div
                          className="svg-next-icon"
                          style={{
                            background:
                              "url('https://static.harasocial.com/svg-funnel/ic_c_check.svg')",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundSize: "20px",
                            width: "20px",
                            height: "20px",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="arrow collapsed">
                      <div
                        className="svg-next-icon"
                        style={{
                          backgroundColor: "rgb(108, 121, 143)",
                          maskImage:
                            "url('https://static.harasocial.com/svg-funnel/ic-arrow-down-line-black.svg')",
                          maskRepeat: "no-repeat",
                          maskSize: "16px",
                          width: "16px",
                          height: "16px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="collapse-body"></div>
                </div>
              </div>
              <div className="connections--row page-connections--faq">
                <div className="icon">
                  <div
                    className="svg-next-icon"
                    style={{
                      background:
                        "url('https://static.harasocial.com/svg-funnel/ic_faq.svg')",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                      backgroundSize: "28px",
                      width: "28px",
                      height: "28px",
                    }}
                  ></div>
                </div>
                <div className="content">
                  <div className="title">Tổng hợp bài hướng dẫn nên đọc:</div>
                  <ul className="articles">
                    {/* <li className="article-item">
                      <a
                        href="https://support.harasocial.com/support/solutions/articles/42000084606-1-s%E1%BB%91-l%E1%BB%97i-th%C6%B0%E1%BB%9Dng-g%E1%BA%B7p-li%C3%AAn-quan-%C4%91%E1%BA%BFn-k%E1%BA%BFt-n%E1%BB%91i-facebook"
                        target="_blank"
                      >
                        Câu hỏi thường gặp về vấn đề kết nối Facebook
                      </a>
                    </li>
                    <li className="article-item">
                      <a
                        href="https://support.harasocial.com/support/solutions/articles/42000090764-c%C3%A1c-tr%C6%B0%E1%BB%9Dng-h%E1%BB%A3p-kh%C3%B4ng-g%E1%BB%ADi-%C4%91%C6%B0%E1%BB%A3c-tin-nh%E1%BA%AFn-%C4%91%E1%BA%BFn-cho-kh%C3%A1ch-h%C3%A0ng"
                        target="_blank"
                      >
                        Những chính sách của Facebook
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConnectionStatus;
